import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  DataDefinitionList,
  Loader,
  Notification,
  Message,
  ButtonOBSOLETED
} from '../../web.common';
import AriaModal from 'react-aria-modal';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import {
  DisplayGuid
} from '../items';
import { DetailsRightBar, NoLink, Divider, Action } from './DetailsRightBar';
import { mappedWeekDays, weekdaysReverse } from '../../enums/weekdays';
import { formatCopenhagen } from '../../common/copenhagenTime';

class SeasonalCourtSlotInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      courtData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { seasonalCourtSlotId } } } = this.props;
    const { api: { seasonalcourts: { getSlot } } } = this.props;

    try {
      const courtData = await getSlot(seasonalCourtSlotId);
      this.setState({ courtData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const { match: { params: { seasonalCourtSlotId } } } = this.props;
    const { courtData, errorMessage, isConfirming } = this.state;
    const { api: { seasonalcourts: { getSlot } } } = this.props;
    let mappedData = null;

    if (courtData) {
      const {
        Id,
        CreatedAt,
        Start,
        End,
        ExternalActivityId,
        SeasonalCourtId,
        Status
      } = courtData;

      mappedData = {
        Id: <DisplayGuid>{Id}</DisplayGuid>,
        CreatedAt: formatCopenhagen(CreatedAt),
        'Start (Copenhagen)': formatCopenhagen(Start),
        'End (Copenhagen)': formatCopenhagen(End),
        ExternalActivityId: <DisplayGuid baseAnchor='/externalactivity'>{ExternalActivityId}</DisplayGuid>,
        SeasonalCourtId: <DisplayGuid baseAnchor='/seasonalcourt'>{SeasonalCourtId}</DisplayGuid>,
        Status
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            {
              isConfirming ? (
                // TODO: extract modal
                <AriaModal
                  titleText='Edit Field'
                  mounted
                  verticallyCenter={false}
                  focusDialog
                  getApplicationNode={() => document.getElementById('app')}
                  dialogClass='dialog-size-normal'
                  scrollDisabled
                >
                  <h3>
                    Are you sure you want to
                    {isConfirming}
                    ?
                  </h3>

                  <ButtonOBSOLETED
                    buttonColor='danger'
                    size='small'
                    onClick={async () => {
                      const {
                        api: {
                          seasonalcourts: {
                            cancelslot
                          }
                        }
                      } = this.props;

                      this.setState({
                        isConfirming: false,
                        courtData: null
                      });

                      try {
                        switch (isConfirming) {
                          case 'cancel':
                            await cancelslot(courtData.Id);
                            break;
                          default: alert('unexpected error: action not found');
                        }
                      }
                      catch (e) {
                        this.setState({
                          errorMessage: new Message('error', `Unable to ${isConfirming} slot: ${e}`)
                        });
                      }

                      const newCourtData = await getSlot(courtData.Id);

                      this.setState({
                        isConfirming: false,
                        courtData: newCourtData
                      });
                    }}
                    disabled={false}
                    buttonContent={`${isConfirming} purchase`}
                    ariaLabel={`${isConfirming} purchase`}
                  >
                    Proceed
                  </ButtonOBSOLETED>
                  <br />
                  <ButtonOBSOLETED
                    buttonColor='gray'
                    size='small'
                    onClick={() => {
                      this.setState({ isConfirming: false });
                    }}
                    disabled={false}
                    buttonContent='Back'
                    ariaLabel='return'
                  >
                    Back
                  </ButtonOBSOLETED>
                </AriaModal>
              ) : ''
            }
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='SeasonalCourtSlot details'
                documentDescription='SeasonalCourtSlot details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Seasonal Court Slot
              </h2>
              <h5 className='main-page-subheader'>{seasonalCourtSlotId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />

                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              <NoLink>None</NoLink>
              <Divider>Actions</Divider>
              <Action action={() => {
                this.setState({ isConfirming: 'cancel' });
              }}
              >
                Cancel
              </Action>
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const SeasonalCourtSlot = withRouter(withApi(connect(({ user }) =>
  ({ isLoggedIn: !!user }), {})(SeasonalCourtSlotInternal)));

SeasonalCourtSlot.requiresLogin = true;
SeasonalCourtSlot.propTypes = { isLoggedIn: PropTypes.bool };

export default SeasonalCourtSlot;